export const verySmall = 480;
export const small = 768;
export const medium = 1024;
export const large = 1280;
export const veryLarge = 1440;

export const smallMobileOnly = `@media (max-width: ${verySmall - 1}px)`;
export const mobileOnly = `@media (max-width: ${small - 1}px)`;
export const tabletOnly = `@media (min-width: ${small}px) and (max-width: ${medium}px)`;
export const desktopOnly = `@media (min-width: ${medium + 1}px)`;
export const tabletAndDown = `@media (max-width: ${medium}px)`;
export const tabletAndUp = `@media (min-width: ${small}px)`;



// WEBPACK FOOTER //
// ./src/breakpoints.js